module.exports = "<app-menu *ngIf=\"menuStatus\"></app-menu>\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"